import { AsyncPipe, CurrencyPipe, NgForOf, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ParcelItemTypesApi, ParcelItemTypesInListDto } from '@buspro/web/apis';
import { injectMutation, injectQuery, injectQueryClient } from '@tanstack/angular-query-experimental';
import { NzDividerComponent } from 'ng-zorro-antd/divider';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { AddParcelItemTypeComponent } from '../add-parcel-item-type/add-parcel-item-type.component';
import { EditParcelItemTypeComponent } from '../edit-parcel-item-types/edit-parcel-item-type.component';

@Component({
  selector: 'tenant-parcel-item-types',
  templateUrl: './parcel-item-types.component.html',
  styleUrls: ['./parcel-item-types.component.css'],
  imports: [
    NgIf,
    AsyncPipe,
    NzPageHeaderModule,
    NgOptimizedImage,
    NzTableComponent,
    CurrencyPipe,
    NzDividerComponent,
    AddParcelItemTypeComponent,
    EditParcelItemTypeComponent,
    NgForOf,
  ],
  standalone: true,
})
export class ParcelItemTypesComponent {
  private parcelItemTypesApi = inject(ParcelItemTypesApi);
  private modalService = inject(NzModalService);
  private notification = inject(NzNotificationService);
  private queryClient = injectQueryClient();

  showAddModal = false;
  showEditModal = false;
  selected$$ = new BehaviorSubject<ParcelItemTypesInListDto | null>(null);

  // Tanstack Query for fetching parcel item types
  parcelItemTypesQuery = injectQuery(() => ({
    queryKey: ['parcel-item-types'],
    queryFn: () => lastValueFrom(this.parcelItemTypesApi.parcelItemTypesControllerGetParcelItemTypes()),
  }));

  // Tanstack Query mutation for deleting parcel item type
  deleteMutation = injectMutation(() => ({
    mutationFn: (id: string) => lastValueFrom(this.parcelItemTypesApi.parcelItemTypesControllerDelete({ id })),
    onSuccess: () => {
      // Invalidate and refetch parcel item types
      this.queryClient.invalidateQueries({ queryKey: ['parcel-item-types'] });
      this.notification.success('✅ Success', 'Parcel Item Type has been deleted successfully');
    },
    onError: (error: any) => {
      console.error('Error deleting parcel item type:', error);
      const errorMessage = error?.error?.detail || 'Failed to delete parcel item type';
      this.notification.error('❌ Error', errorMessage);
    },
  }));

  delete(data: ParcelItemTypesInListDto) {
    this.modalService.confirm({
      nzTitle: `Are you sure delete this parcel item type - ${data.category}?`,
      nzContent: '<b style="color: red;">The action is irreversible. Select Yes to continue</b>',
      nzOkText: 'Yes',
      nzOkType: 'primary',
      nzOkDanger: true,
      nzOkLoading: this.deleteMutation.isPending(),
      nzOnOk: () => this.deleteMutation.mutate(data.id),
      nzCancelText: 'No',
      nzOnCancel: () => console.log('Cancel'),
    });
  }
}
